import { cn } from '#/utils/cn';

interface RichTextProps {
  /** Trusted rich-text HTML, e.g. CMS-authored copy from the content API. */
  html: string;
  className?: string;
}

/**
 * Renders trusted rich text (HTML) from the content API.
 *
 * Centralizes the single `dangerouslySetInnerHTML` call so section descriptions
 * stay visually consistent and the trust boundary lives in one auditable place.
 * The content source must be trusted (CMS-authored); if that ever changes, add
 * sanitization (e.g. DOMPurify) here only — every call site flows through this.
 */
export function RichText({ html, className }: RichTextProps) {
  return (
    <div
      className={cn('prose', className)}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
